module.exports = __webpack_public_path__ + "static/media/1012987.4c3777f4.jpg";